import React from "react";
import { isEmptyString } from "utils/types/typeguards";
import { useTranslation } from "react-i18next";

type Props = {
	productTextId: string
}

function SingleProductPageBottomText({
	productTextId
}: Props) {

	const { t } = useTranslation();

	const bigText = t([ `products.${ productTextId }.bigText`, "" ]);
	const bigTextGradient = t([ `products.${ productTextId }.bigTextGradient`, "" ]);

	return (
		<>
			{
				!(isEmptyString(bigText) && isEmptyString(bigTextGradient)) &&
                <div className="container">
                    <h2 className="mt-10 font-medium">
						<span>
							{
								!isEmptyString(bigTextGradient) &&
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-purple-600 me-2">{ bigTextGradient }</span>
							}
							{
								!isEmptyString(bigText) &&
                                <span>{ bigText }</span>
							}
						</span>
                    </h2>
                </div>
			}
		</>
	);
}

export default SingleProductPageBottomText;